import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceSettingsOrganizationMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceSettingsOrganizationMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceSettingsOrganizationMember","document":WorkspaceSettingsOrganizationMemberDocument}} as const;
export type WorkspaceSettingsOrganizationMemberQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type WorkspaceSettingsOrganizationMemberQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'email' | 'id'>
    & { domain?: Types.Maybe<(
      { __typename: 'DomainOrganization' }
      & Pick<Types.DomainOrganization, 'displayName'>
    )> }
  )> }
);

/**
 * __useWorkspaceSettingsOrganizationMemberQuery__
 *
 * To run a query within a React component, call `useWorkspaceSettingsOrganizationMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSettingsOrganizationMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSettingsOrganizationMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useWorkspaceSettingsOrganizationMemberQuery(
  baseOptions: TrelloQueryHookOptions<
    WorkspaceSettingsOrganizationMemberQuery,
    WorkspaceSettingsOrganizationMemberQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: WorkspaceSettingsOrganizationMemberDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    WorkspaceSettingsOrganizationMemberQuery,
    WorkspaceSettingsOrganizationMemberQueryVariables
  >(WorkspaceSettingsOrganizationMemberDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useWorkspaceSettingsOrganizationMemberLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    WorkspaceSettingsOrganizationMemberQuery,
    WorkspaceSettingsOrganizationMemberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspaceSettingsOrganizationMemberQuery,
    WorkspaceSettingsOrganizationMemberQueryVariables
  >(WorkspaceSettingsOrganizationMemberDocument, options);
}
export type WorkspaceSettingsOrganizationMemberQueryHookResult = ReturnType<
  typeof useWorkspaceSettingsOrganizationMemberQuery
>;
export type WorkspaceSettingsOrganizationMemberLazyQueryHookResult = ReturnType<
  typeof useWorkspaceSettingsOrganizationMemberLazyQuery
>;
export type WorkspaceSettingsOrganizationMemberQueryResult = Apollo.QueryResult<
  WorkspaceSettingsOrganizationMemberQuery,
  WorkspaceSettingsOrganizationMemberQueryVariables
>;
